import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ width, height, fill = "#FFF" }) => {
  return (
    <svg
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        fill={"none"}
        x="1.5"
        y="1.5"
        width="13"
        height="13"
        rx="6.5"
        stroke="#89959C"
        strokeWidth="2"
      />
    </svg>
  );
};

export default memo(Icon);
